import { render } from "./DialogBase.vue?vue&type=template&id=4b2610de&scoped=true"
import script from "./DialogBase.vue?vue&type=script&lang=js"
export * from "./DialogBase.vue?vue&type=script&lang=js"

import "./DialogBase.vue?vue&type=style&index=0&id=4b2610de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2610de"]])

export default __exports__